import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  CreateCloudEnvironmentDialogData,
  CreateCloudEnvironmentRequest,
  CreateCloudEnvironmentResponse,
  ErmDevOpsApiClientService
} from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-create-environment',
  templateUrl: './create-environment.component.html',
  styleUrls: ['./create-environment.component.scss']
})
export class CreateEnvironmentComponent {

  isSaving: boolean = false;
  createCloudEnvironmentRequest: CreateCloudEnvironmentRequest;
  createCloudEnvironmentResponse?: CreateCloudEnvironmentResponse;
  environmentVersions?: string[];

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public createCloudEnvironmentDialogData: CreateCloudEnvironmentDialogData,
    public dialogRef: MatDialogRef<CreateEnvironmentComponent>) {
    this.environmentVersions = createCloudEnvironmentDialogData.environmentVersions;
    this.createCloudEnvironmentRequest = {
      accountId: createCloudEnvironmentDialogData.accountId,
      isProduction: false,
      deploymentType: createCloudEnvironmentDialogData.defaultDeploymentType
    }
  }

  async save(): Promise<void> {
    try {

      if (this.createCloudEnvironmentRequest.schemaName?.includes('/') || this.createCloudEnvironmentRequest.schemaName?.includes('\\')) {
        alert(`Schema Name must not contain '/' or  '\\' `);
        return;
      }

      this.isSaving = true;
      const createCloudEnvironmentResponse = await this.ermDevOpsApiClient.createFleetDefinition(this.createCloudEnvironmentRequest);
      this.createCloudEnvironmentResponse = createCloudEnvironmentResponse.body as CreateCloudEnvironmentResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.dialogRef.close({ data: this.createCloudEnvironmentResponse });
  }

}
